import React from "react";

export default function About() {
  return (
    <>
      <article id="about">
        <h4>Who are we?</h4>
        <p>
          We're an enthusiastic group of developers from Haifa. Some of us are
          professionals, some are still learning, but all of us agree upon one
          thing: Haifa offers barely enough for local developers to thrive.
        </p>
        <p>
          Nobody wants to move far away from the place they call home just to
          establish a career. We don't think anyone should. That's why we've
          established Haifa:Dev, so that all of Haifa's developers will have{" "}
          <b>a reason to stay in Haifa</b>.
        </p>
      </article>

      <article>
        <h4>What do we want?</h4>
        <p>To allow ourselves and others a fulfilling career as software developers without having to move elsewhere.</p>
        <p>
          Our goal is to bring professional software-related content to Haifa{" "}
          <b>for free</b>. We aim to organize meetups and other events that can
          help developers in (and around) Haifa develop their career without the need to
          travel accross the country.
        </p>
        <p>
          currently, due to the COVID-19 pandemic, we're organizing out meetups online. Stay tuned for new content via our <a href="https://www.meetup.com/Haifa-dev/">Meetup</a> group.
        </p>
      </article>

      <article>
        <h4>How do we do that?</h4>
        <p>
          Each of our founders and organizers give their all hee with passion and dedication to the cause, 
          in order to bring high quality professionals and organize the best quality meetups we possibly can.
        </p>
        <p>
          With no commercial sponsors involved, we're doing our best to adhere our meetups for the highest possible standard.
        </p>
      </article>
    </>
  );
}
